const formats = ["PDF", "CSV", "XLSX", "YML", "JSON", "XML"];
export const REPORT_FORMATS_SHORT = formats.map((format) => ({ label: format, value: format }));
export const REPORT_FORMATS = [
  { label: "Portable Document Format (PDF)", value: "PDF" },
  { label: "Comma-Separated Values (CSV)", value: "CSV" },
  { label: "Excel (XLSX)", value: "XLSX" },
  { label: "YAML", value: "YML" },
  { label: "JSON", value: "JSON" },
  { label: "XML", value: "XML" }
];
export const DEFAULT_FORMAT = "PDF";
